import { Info } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface UserActivityTabProps {
  userId: string;
}

export function UserActivityTab({ userId: _userId }: UserActivityTabProps) {
  void _userId;
  return (
    <div className="space-y-6">
      <Card className="border-blue-200 bg-blue-50">
        <CardContent className="p-4 flex items-start gap-3">
          <Info className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
          <div>
            <p className="font-medium text-blue-900">User Activity Log</p>
            <p className="text-sm text-blue-700 mt-1">
              Track user login history, actions performed, and system events.
              This feature provides comprehensive audit trails for security and compliance.
            </p>
            <div className="mt-3">
              <Badge variant="outline" className="bg-white">
                Coming in Phase 2
              </Badge>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-12 text-center">
          <div className="text-muted-foreground">
            <p className="text-lg font-medium">Activity tracking not yet enabled</p>
            <p className="text-sm mt-2">
              User activity logs will be available in the next release.
              <br />
              This will include login history, IP addresses, and action logs.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
